import { useState } from 'react';
import { HexColorPicker } from "react-colorful";

function ShadowSelector(props) {
    const [pickerStyle, setPickerStyle] = useState({ display: "none" });
    const [buttonColour, setButtonColour] = useState(props.colour);
    const [onOff, setOnOff] = useState("<")

    function openClose() {
        if (pickerStyle.display === "none") {
            setPickerStyle({ display: "block" });
        }
        else {
            setPickerStyle({ display: "none" });
        }
    }

    function handleBlur() {
        setPickerStyle({ display: "none" });
    }

    function handleChange(color) {
        if (onOff === "<") {
            setOnOff("Off")
        }
        props.setStyle(`filter: drop-shadow( 3px 3px 0px ${color});`);
        setButtonColour(color);
    }

    return (
        <div className="uiElementDouble">
            <h3 onClick={() => openClose()}>{props.title}</h3>
            <button style={{ background: buttonColour }} className="colourButton" onBlur={handleBlur} onClick={() => openClose()} />
            <div className="pickerContainer" style={pickerStyle}>
                <HexColorPicker color={"#000000"} onChange={color => handleChange(color)} />
            </div>
            <button className="colourButton off" onClick={() => { props.setStyle(""); setOnOff("<") }}>{onOff}</button>
            {/* <input type="color" defaultValue={props.colour} onblur={e => props.setColour(e.target.value)} /> */}
        </div>
    );
}

export default ShadowSelector;